import { Link, useLocation } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import Seo from '@/components/feature/Seo';

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <Seo
        title="页面走丢了 | 瓜田黑料"
        description="你访问的页面不存在或已被移动，可以回到瓜田黑料首页或专题列表继续浏览时间线复盘内容。"
        keywords="瓜田黑料,页面不存在,404"
        path={location.pathname}
      />
      <section className="bg-background-50">
        <div className="mx-auto flex min-h-[60vh] w-full max-w-3xl flex-col items-center justify-center px-4 py-20 text-center md:px-6">
          <span className="font-heading text-6xl font-black text-primary-500 md:text-8xl">404</span>
          <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            这个瓜田里没有这条路径
          </h1>
          <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
            页面可能已经被移动或替换。你可以回首页重新开始，或者直接去专题列表挑一个方向吃瓜。
          </p>
          <p className="mt-3 rounded-full bg-background-100 px-4 py-1.5 text-xs text-foreground-500">
            {location.pathname}
          </p>
          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-home-4-line"></i>
              返回首页
            </Link>
            <Link
              to="/topics"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-300 px-6 py-3 text-sm text-foreground-800 transition-colors hover:bg-background-100"
            >
              <i className="ri-compasses-2-line"></i>
              浏览全部专题
            </Link>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}